import React from 'react'
import { useRouter } from 'next/router'

import { HomeIcon, RankIcon, ScheduleIcon, SeriesIcon } from '@shared/components/ctIcons'
import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'
import CustomLink from '../customLink'
// import { Button } from 'react-bootstrap'
const MobileMenu = () => {
  const router = useRouter()
  return (
    <ul className="mobileMenu d-flex d-md-none text-center text-uppercase font-semi mb-0">
      <li>
        <CustomLink href={allRoutes.home} prefetch={false}>
          <a className={`${router.pathname === allRoutes.home ? 'active' : ''}`}>
            <HomeIcon />
            {'Home'}{' '}
          </a>
        </CustomLink>
      </li>
      <li>
        <CustomLink href={allRoutes.fixturesNew} prefetch={false}>
          <a className={`${router.pathname.includes(allRoutes.fixturesNew.replaceAll('/', '')) && 'active'}`}>
            <ScheduleIcon />
            {'Fixtures'}
          </a>
        </CustomLink>
      </li>
      <li>
        <CustomLink href={allRoutes.cricketSeriesNew} prefetch={false}>
          <a className={`${router.pathname.includes(allRoutes.cricketSeriesNew.substring(1)) && 'active'}`}>
            <SeriesIcon />
            {'Series'}
          </a>
        </CustomLink>
      </li>
      {/* <li>
        <CustomLink href={allRoutes.fantasyCricketTips} prefetch={false}>
          <a className={`${router.pathname.includes(allRoutes.fantasyCricketTips.replaceAll('/', '')) && 'active'}`}>
            <FantasyMenuIcon />
            FANTASY TIPS
            {"Fantasy"}
          </a>
        </CustomLink>
      </li> */}
      <li>
        <CustomLink href={allRoutes.iccRankings} prefetch={false}>
          <a className={`${router.pathname.includes(allRoutes.iccRankings.replaceAll('/', '')) && 'active'}`}>
            <RankIcon />
            {'Rankings'}
          </a>
        </CustomLink>
      </li>
    </ul>
  )
}

export default MobileMenu
